import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

interface SuspensionBannerProps {
  isVisible: boolean;
  onClose?: () => void;
}

const SuspensionBanner: React.FC<SuspensionBannerProps> = ({ isVisible, onClose }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white shadow-lg">
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center space-x-3">
          <AlertTriangle className="h-5 w-5 flex-shrink-0" />
          <div>
            <p className="font-semibold">Account Suspended</p>
            <p className="text-sm text-red-100">
              Your account has been suspended. Please contact support to reactivate your account.
            </p>
          </div>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="text-red-100 hover:text-white transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SuspensionBanner;